
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';

import saveAs from 'file-saver';

// import letterBack from '_images/page-ten/caixa-carta.png';

import html2canvas from 'html2canvas';

export default class LetterBoxController {
	constructor($log, $state, $timeout, Dialog, Session) {
		'ngInject';
		this.$log = $log;
		this.$state = $state;
		this.$timeout = $timeout;
		this.Dialog = Dialog;
		this.Session = Session;
		// this.letterBack = letterBack
		this.saveAs = saveAs;

		this.modelLetter = [
			//
			{word:"Local, data", editorEnabled:true, editableWord:"", class: "data", placeholder: "Local, data", feedback: ""},
			{word:"Cumprimento", editorEnabled:false, editableWord:"", class: "cumprimento", placeholder: "Cumprimento", feedback: ""},
			{word:"Corpo da carta", editorEnabled:false, editableWord:"", class: "corpo", placeholder: "Corpo da carta", feedback: ""},
			{word:"Despedida", editorEnabled:false, editableWord:"", class: "despedida", placeholder: "Despedida", feedback: ""},
			{word:"Assinatura", editorEnabled:false, editableWord:"", class: "assinatura", placeholder: "Assinatura", feedback: ""}
		//
		];
	}    

	$onInit(){
		this.savedLetter = this.Session.get().letter;
		if(!_.isEqual(this.savedLetter, []))
			this.letter = this.savedLetter;
		else
			this.letter = _.cloneDeep(this.modelLetter);
	}

	enableEditor(w) {
		w.feedback = "";
		if(!this.print){
			w.editorEnabled = true;
			if(w.word === w.placeholder)
				w.editableWord = "";
			else
				w.editableWord = w.word;
		}
	}


	next(w, index){
		if(w.editableWord !== ""){
			w.word = w.editableWord;
			if(this.letter.length>index+1)
				this.letter[index+1].editorEnabled = true;
		} else {
			w.word = w.placeholder;
		}
		w.editorEnabled = false;
	}

	saveToImage(){
		let node = angular.element(document.getElementById('printable'))[0];
		//this.$log.log(node);
		//let optionX = (node.offsetParent.offsetLeft+node.offsetLeft)+76;  
		//let $ctrl = this; 

		html2canvas(node,{
			useCORS: true,
			logging: false
		}).then(function(canvas) { 
			// let win = window.open();		
			// $ctrl.$log.log(canvas);	
			// win.document.write('<img src="'+canvas.toDataURL("image/png")+'"/>');
			
			canvas.toBlob(function(blob) {
				saveAs(blob, "Minha carta.png");
			});
		});
	}

	saveToSession(){
		this.Session.saveLetter(this.letter);
	}

	ok(){
		for(let i = 0; i <= this.letter.length-1; i++){
			if(this.letter[i].word === this.modelLetter[i].word){
				this.letter[i].feedback = "";
				this.$timeout(()=>this.letter[i].feedback = "fail",100);
				break;
			} else if(i === this.letter.length-1){				
				this.modalInstance.close(true);
			} else {
				continue;
			}
		}		
	}

	close(){
		this.Session.saveLetter(this.letter);
		this.modalInstance.dismiss('cancel');
	}
}


// WEBPACK FOOTER //
// ./src/app/components/ui/letter-box/letter-box.controller.js